import { render, staticRenderFns } from "./user-item.vue?vue&type=template&id=8d100834&scoped=true&"
import script from "./user-item.vue?vue&type=script&lang=js&"
export * from "./user-item.vue?vue&type=script&lang=js&"
import style0 from "./user-item.vue?vue&type=style&index=0&id=8d100834&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.0_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17._dqvcgk3en6wwbxrhlb6nnpgame/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d100834",
  null
  
)

export default component.exports